export const CACHE_KEY_LIST_TECH_PARK = 'techParks';
export const CACHE_KEY_TECH_PARK = 'techPark-one';
export const ROUTE_PATH_TECH_PARK = '/configuration/tech-parks';
export const TRANSLATION_PREFIX_TECH_PARK = 'techPark';
export const SECURITY_KEY_TECH_PARK = 'TECH_PARK';

